import { type CartValidationDetail, CouponExceptionCode, type CouponExceptionCodeType } from '@hooks-api/types/dataModel/coupon'

export const isValidateErrorCode = <ErrorCodes extends Record<string, string | number>>(code: string | number, codes: ErrorCodes): code is ErrorCodes[keyof ErrorCodes] => {
  return Object.values(codes).includes(code)
}

export interface GetCouponExceptionMessageReturn {
  message: string
  value?: {
    coupon?: string
    sku?: string
  }
}

export const DEFAULT_COUPON_EXCEPTION_MESSAGE: GetCouponExceptionMessageReturn = {
  message: '訂單包含已無法使用的優惠券或贈品，請重整購物車並重新確認優惠',
}

export const getCouponExceptionMessage = (code?: CouponExceptionCodeType, detail?: CartValidationDetail): GetCouponExceptionMessageReturn => {
  switch (code) {
    case CouponExceptionCode.COUPON_NO_TICKET:
      return {
        message: '訂單包含已發送完畢的優惠券，請重整購物車並重新確認優惠',
      }
    case CouponExceptionCode.COUPON_REACH_USER_LIMIT:
      return {
        message: '訂單包含已不適用的優惠券，請重整購物車並重新確認優惠',
      }
    case CouponExceptionCode.COUPON_EXPIRED:
      return {
        message: '訂單包含已過期的優惠券，請重整購物車並重新確認優惠',
      }
    case CouponExceptionCode.COUPON_NOT_STARTED:
      return {
        message: '訂單包含尚未開始的優惠券，請重整購物車並重新確認優惠',
      }
    case CouponExceptionCode.COUPON_NO_PERMISSION:
      return {
        message: '訂單包含已不適用的優惠券，請重整購物車並重新確認優惠',
      }
    case CouponExceptionCode.COUPON_CODE_NOT_EXIST:
      return {
        message: '訂單包含已不存在的優惠券，請重整購物車並重新確認優惠',
      }
    case CouponExceptionCode.MANUAL_COUPONS_FAILED:
      return {
        message: '訂單包含已無法使用的優惠券，請聯繫客服 : 「{{coupon}}」',
        value: {
          coupon: detail?.coupon_name || '',
        },
      }
    case CouponExceptionCode.WRONG_GIFT_SELECTION:
      return {
        message: '訂單包含已無法提供的贈品 「{{sku}}」，請重新選擇',
        value: {
          sku: detail?.sku || '',
        },
      }
    case CouponExceptionCode.KOL_COUPON_EXCEED:
      return {
        message: '訂單包含無法同時使用的優惠券，請重整購物車並重新確認優惠',
      }
    case CouponExceptionCode.USER_RESTRICTION:
      return {
        message: '訂單包含已不適用的優惠券，請重整購物車並重新確認優惠',
      }
    case CouponExceptionCode.INVALID_CRITERION_SELECTION:
    case CouponExceptionCode.LOSE_CRITERION_SELECTION:
      return DEFAULT_COUPON_EXCEPTION_MESSAGE
    default:
      return detail?.message ? { message: detail.message } : DEFAULT_COUPON_EXCEPTION_MESSAGE
  }
}

export interface GetCouponManualInputExceptionMessageReturn {
  message: string
  value?: {
    firstCoupon?: string
    secondCoupon?: string
    code?: 10007 | 10009 | 10011 | 10012
    message?: string
  }
}
export const getCouponManualInputExceptionMessage = (code?: CouponExceptionCodeType, detail?: CartValidationDetail): GetCouponManualInputExceptionMessageReturn => {
  switch (code) {
    case CouponExceptionCode.COUPON_NO_TICKET:
      return {
        message: '晚來一步…優惠已被使用完畢',
      }
    case CouponExceptionCode.COUPON_REACH_USER_LIMIT:
      return {
        message: '已經使用過囉！',
      }
    case CouponExceptionCode.COUPON_EXPIRED:
      return {
        message: '使用期限已過',
      }
    case CouponExceptionCode.COUPON_NOT_STARTED:
      return {
        message: '尚未開始',
      }
    case CouponExceptionCode.COUPON_NO_PERMISSION:
      return {
        message: '抱歉，不符合優惠資格',
      }
    case CouponExceptionCode.COUPON_CODE_NOT_EXIST:
      return {
        message: '哎呀，沒有這個優惠碼',
      }
    case CouponExceptionCode.MANUAL_COUPONS_FAILED:
      return {
        message: '優惠異常，請洽客服',
      }
    case CouponExceptionCode.KOL_COUPON_EXCEED:
      return {
        message: '「{{firstCoupon}}」、「{{secondCoupon}}」無法同時使用呦',
        value: {
          firstCoupon: detail?.first_coupon_code || '第一張優惠券',
          secondCoupon: detail?.second_coupon_code || '第二張優惠券',
        },
      }
    default:
      return {
        message: '非預期的錯誤 code={{code}} message={{message}}',
        value: {
          code,
          message: detail?.message || '',
        },
      }
  }
}
